import gameConfig from "../gameConfig";

export const getActiveGameKeys = () => {
  return [
    ...gameConfig.keys.keysFirstPlayer,
    ...gameConfig.keys.keysSecondPlayer,
  ];
};

export const getKeyAnswersArrIndex = (key) => {
  const first = gameConfig.keys.keysFirstPlayer.indexOf(key);
  const second = gameConfig.keys.keysSecondPlayer.indexOf(key);
  if (first >= 0) {
    return first;
  } else {
    return second;
  }
};

export const getKeyPair = (key) => {
  const playerName = getPlayerNameByKey(key);
  const keyIndex = getKeyAnswersArrIndex(key);
  let pairKey = null;
  if (playerName === gameConfig.playerOneName) {
    pairKey = gameConfig.keys.keysSecondPlayer[keyIndex];
  } else if (playerName === gameConfig.playerTwoName) {
    pairKey = gameConfig.keys.keysFirstPlayer[keyIndex];
  } else {
    console.warn("Can't find key's pair");
  }
  return pairKey;
};

export const getPlayerNameByKey = (key) => {
  let playerName = null;
  if (gameConfig.keys.keysFirstPlayer.includes(key)) {
    playerName = gameConfig.playerOneName;
  } else if (gameConfig.keys.keysSecondPlayer.includes(key)) {
    playerName = gameConfig.playerTwoName;
  }
  return playerName;
};
